<template>
  <div class="container py-5" v-if="usuario">
    <h2 class="mb-4">Perfil do Usuário</h2>

    <p><strong>Nome:</strong> {{ usuario.nome }}</p>
    <p><strong>E-mail:</strong> {{ usuario.email }}</p>
    <p>
      <strong>Tipo:</strong>
      <span :class="usuario.tipo === 'admin' ? 'badge px-5 py-2 bg-warning text-dark ms-3' : 'badge px-5 py-2 bg-info text-dark ms-3'">
        {{ usuario.tipo }}
      </span>
    </p>

    <p>
      <strong>Currículo:</strong>
      <template v-if="curriculo">
        <button
          class="btn btn-outline-primary me-2"
          @click="visualizarCurriculo"
        >
          Ver Currículo
        </button>
        <span class="text-muted ms-2">(enviado em {{ curriculo.data }})</span>
      </template>
      <template v-else>
        <span class="text-muted ms-2">Nenhum currículo enviado</span>
      </template>
    </p>

    <hr class="my-4" />
    <h4 class="mb-3">Dados Pessoais</h4>

    <template v-if="souEu || (logado?.tipo === 'admin')">
      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label">Telefone/Celular</label>
          <input
            v-model="dados.telefone"
            @input="dados.telefone = maskTelefone(dados.telefone)"
            type="text"
            class="form-control"
            :readonly="!souEu"
            v-mask="['(##) #####-####', '(##) ####-####']"
          />
        </div>
        <div class="col-md-6">
          <label class="form-label">CPF</label>
          <input
            v-model="dados.cpf"
            @input="dados.cpf = maskCPF(dados.cpf)"
            type="text"
            class="form-control"
            :readonly="!souEu"
            v-mask="'###.###.###-##'"
          />
        </div>
        <div class="col-12">
          <label class="form-label">Endereço</label>
          <input v-model="dados.endereco" type="text" class="form-control" :readonly="!souEu" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Cidade</label>
          <input v-model="dados.cidade" type="text" class="form-control" :readonly="!souEu" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Estado</label>
          <input v-model="dados.estado" type="text" class="form-control" :readonly="!souEu" />
        </div>
 
        <div class="col-md-6">
          <label class="form-label">Escolaridade</label>
          <input v-model="dados.escolaridade" type="text" class="form-control" :readonly="!souEu" />
        </div>
        <div class="col-md-12">
          <label class="form-label">Experiência Profissional</label>
          <input v-model="dados.experiencia" type="text" class="form-control" :readonly="!souEu" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Gênero</label>
          <input v-model="dados.genero" type="text" class="form-control" :readonly="!souEu" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Raça/Cor</label>
          <input v-model="dados.raca" type="text" class="form-control" :readonly="!souEu" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Pessoa com Deficiência</label>
          <input v-model="dados.deficiencia" type="text" class="form-control" :readonly="!souEu" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Nome Social</label>
          <input v-model="dados.nome_social" type="text" class="form-control" :readonly="!souEu" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Naturalidade</label>
          <input v-model="dados.naturalidade" type="text" class="form-control" :readonly="!souEu" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Está Trabalhando Atualmente?</label>
          <input v-model="dados.trabalhando_atualmente" type="text" class="form-control" :readonly="!souEu" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Data de Nascimento</label>
          <input v-model="dados.data_nascimento" type="date" class="form-control" :readonly="!souEu" />
        </div>
       <div class="col-md-6">
  <label class="form-label">Pretensão Salarial</label>
  <div class="position-relative">
    <input
      v-model.number="dados.pretensao_salarial"
      type="range"
      class="form-range"
      min="1000"
      max="30000"
      step="100"
      :disabled="!souEu"
      style="margin-bottom: 0.5rem;"
      :readonly="!souEu"
    />

    <!-- Marcadores de faixa -->
    <div class="d-flex justify-content-between text-muted small px-1">
      <span>R$ 1.000</span>
      <span>R$ 5.000</span>
      <span>R$ 10.000</span>
      <span>R$ 20.000</span>
      <span>R$ 30.000</span>
    </div>

    <!-- Valor dinâmico exibido -->
    <div class="text-end mt-1">
      <span class="badge bg-primary fs-6">
        R$ {{ Number(dados.pretensao_salarial).toLocaleString('pt-BR') }}
      </span>
    </div>
  </div>
</div>

      </div>

      <button
        v-if="souEu"
        class="btn btn-success mt-4"
        @click="salvarDados"
      >
        Salvar Alterações
      </button>
    </template>

    <template v-else>
      <p class="text-muted">Essas informações são privadas e visíveis apenas ao próprio usuário e à administração.</p>
    </template>
  </div>
</template>

<script>
import api from '../services/api';

export default {
  name: "UsuarioPerfilVie",
  data() {
    return {
      usuario: null,
      curriculo: null,
      logado: JSON.parse(localStorage.getItem('usuario')),

      dados: {
        telefone: '',
        cpf: '',
        endereco: '',
        cidade: '',
        estado: '',
        escolaridade: '',
        experiencia: '',
        genero: '',
        raca: '',
        deficiencia: '',
        nome_social: '',
        naturalidade: '',
        trabalhando_atualmente: '',
        data_nascimento: '',
        pretensao_salarial: '',
      },

      souEu: false,
    };
  },
  computed: {
     curriculoUrl() {
      if (!this.curriculo || !this.curriculo.caminho) return '';
      const caminho = this.curriculo.caminho.startsWith('/')
        ? this.curriculo.caminho.slice(1)
        : this.curriculo.caminho;
      const backEndBase = `${window.location.protocol}//${window.location.host}/oportunidades-rh/backend/`;
      return new URL(caminho, backEndBase).href;
    },
  },
  mounted() {
    const id = this.$route.params.id;
    const logado = JSON.parse(localStorage.getItem('usuario'));
    this.souEu = logado?.id == id;

    api.get(`buscar_usuario.php?id=${id}`)
      .then(res => {
        this.usuario = res.data;
        if (res.data.dados) {
          try {
            this.dados = JSON.parse(res.data.dados);
          } catch {
            this.dados = {};
          }
        }
        return api.get(`buscar_curriculo.php?usuario_id=${id}`);
      })
      .then(res => {
        if (res.data && res.data.caminho_arquivo) {
          this.curriculo = {
            caminho: res.data.caminho_arquivo,
            data: new Date(res.data.data_upload).toLocaleDateString(),
          };
        }
      })
      .catch(() => alert('Erro ao carregar dados do usuário ou currículo.'));
  },
  methods: {
    visualizarCurriculo() {
      if (this.curriculoUrl !== '#') {
        window.open(this.curriculoUrl, '_blank');
      }
    },
    salvarDados() {
      const id = this.$route.params.id;

      api.post('atualizar_dados_usuario.php', {
        id,
        dados: this.dados,
      })
        .then(() => {
          alert('Dados atualizados com sucesso!');
        })
        .catch(() => {
          alert('Erro ao atualizar os dados.');
        });
    },
    maskCPF(value) {
      return value
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    },
    maskTelefone(value) {
      return value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1-$2')
        .replace(/(\d{4})(\d{1,4})$/, '$1-$2');
    }
  }
};
</script>

<style scoped>
input[type="range"]::-webkit-slider-runnable-track {
  background-color: #444; /* mais escuro */
  height: 6px;
  border-radius: 5px;
}

input[type="range"]::-moz-range-track {
  background-color: #444;
  height: 6px;
  border-radius: 5px;
}

input[type="range"]::-ms-track {
  background-color: #444;
  height: 6px;
  border-radius: 5px;
}

</style>